import {KinesisEvent} from "../kinesis.event";
import {KINESIS} from "../../kinesis.consts";

export class ExitKinesisEvent extends KinesisEvent {
  constructor() {
    super(KINESIS.CATEGORY.bolao, KINESIS.ACTION.exit);
  }
}